import { render, staticRenderFns } from "./RequestParams.vue?vue&type=template&id=8d21fafc&scoped=true&"
import script from "./RequestParams.vue?vue&type=script&lang=js&"
export * from "./RequestParams.vue?vue&type=script&lang=js&"
import style0 from "./RequestParams.vue?vue&type=style&index=0&id=8d21fafc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d21fafc",
  null
  
)

export default component.exports